import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import Button from 'components/Button';
import Icon from 'components/Kizen/Icon';
import css from '@emotion/css';

const StyledButton = styled(Button)`
  height: 20px;

  ${({ enableRightMargin = false }) =>
    enableRightMargin &&
    css`
      margin-right: 20px;
    `}
`;

const StyledIcon = styled(Icon)`
  margin-right: 8px;

  > svg {
    height: 12px;
    width: auto;
  }
`;

function BackButton({
  onClick,
  children,
  color = 'blue',
  to,
  as,
  preventDefault,
  enableRightMargin = false,
  ...others
}) {
  return (
    <StyledButton
      noSpace
      as={to ? Link : as}
      variant="text"
      color={color}
      onClick={onClick}
      to={to}
      preventDefault={to ? false : preventDefault}
      enableRightMargin={enableRightMargin}
      {...others}
    >
      <StyledIcon icon="chevron-left" color="inherit" />
      {children}
    </StyledButton>
  );
}

export default BackButton;
